module.exports = __webpack_public_path__ + "img/ok.2bc37bfc.png";